import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/guidelines")({
  head: () => ({
    meta: [
      { title: "Community Guidelines — Quibblies" },
      {
        name: "description",
        content:
          "The rules that keep Quibblies a safe, adults-only home for original fiction: what you may publish, how moderation works and how to report content.",
      },
      { property: "og:title", content: "Community Guidelines — Quibblies" },
      {
        property: "og:description",
        content: "How Quibblies moderates original fiction and keeps the community safe.",
      },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: GuidelinesPage,
});

const SECTIONS = [
  {
    title: "Quibblies is 18+",
    body: "Every account holder must be at least 18 years old. We ask for your date of birth at sign-up and keep it private. Accounts found to belong to minors are removed.",
  },
  {
    title: "Publish only your own work",
    body: "Post original fiction you wrote. Plagiarism, AI-laundered reposts of other authors' work and unlicensed fan content are removed on sight.",
  },
  {
    title: "Label what you write",
    body: "Use content notices honestly. Readers rely on them to choose what they open. Mislabelled work is sent back with changes requested.",
  },
  {
    title: "Nothing illegal, ever",
    body: "No sexual content involving minors, no incitement to violence, no doxxing, no content that targets a person or group for harassment. These are permanent bans, not warnings.",
  },
  {
    title: "Review before publication",
    body: "Every story goes Draft → Submitted → Under Review → Approved → Published. Nothing goes live automatically. Moderators may approve, request changes, or reject with feedback.",
  },
  {
    title: "Comments are part of the work",
    body: "Critique the writing, not the writer. Authors may disable comments on any story, and moderators remove abusive threads.",
  },
  {
    title: "Reporting",
    body: "Use the report action on any story, comment or profile. Reports are triaged by our moderation team, and repeat offenders lose posting privileges.",
  },
];

function GuidelinesPage() {
  return (
    <article className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
      <h1 className="font-display text-4xl text-foreground">Community Guidelines</h1>
      <p className="mt-3 text-muted-foreground">
        Short version: write your own work, label it honestly, and treat other people like people.
      </p>
      <div className="mt-10 space-y-8">
        {SECTIONS.map((section) => (
          <section key={section.title}>
            <h2 className="font-display text-xl text-foreground">{section.title}</h2>
            <p className="mt-2 leading-relaxed text-muted-foreground">{section.body}</p>
          </section>
        ))}
      </div>
    </article>
  );
}
